import React, { forwardRef, useRef } from "react";
import { useToggleButton } from "@react-aria/button";
import { useToggleState } from "@react-stately/toggle";

import Button from "./Button";
import { ButtonProps } from "./button.type";

type ToggleProps = ButtonProps & {
  isSelected?: boolean;
  defaultSelected?: boolean;
  onChange?: (isSelected: boolean) => void;
};

const ToggleButton = forwardRef<HTMLButtonElement, ToggleProps>(
  (props, ref) => {
    const { variant, isSelected, defaultSelected, onChange, ...other } = props;
    const state = useToggleState({ isSelected, onChange, defaultSelected });
    const defaultRef = useRef(null);
    const getRef = (): React.RefObject<HTMLButtonElement> => {
      if (ref === null) {
        return defaultRef;
      }
      if (typeof ref === "function") {
        return defaultRef;
      }
      return ref;
    };

    let { buttonProps } = useToggleButton({}, state, getRef());

    return (
      <Button
        variant="button"
        {...other}
        {...buttonProps}
        ref={ref}
        className={state.isSelected ? "active" : undefined}
      >
        Toggle
      </Button>
    );
  }
);

export default ToggleButton;
